import AssignmentResultCard from "./AssignmentResultCard";

export default AssignmentResultCard;
